import { Link, Typography } from "@mui/material";
import { Fragment } from "react";
import { commonStyles } from "../../common/commonStyles";

const MEMBER_DASHBOARD_LABEL = "Member Dashboard";
// Member accounts go to the Member Dashboard home (the staff navbar link opens its /login page).
const MEMBER_DASHBOARD_URL = "https://dashboard.chamberperksapp.com";

// Member-account guidance names the Member Dashboard. Render that phrase as a
// link so the alert is self-contained and the user can reach it directly.
const renderMessage = (message: string) => {
  const parts = message.split(MEMBER_DASHBOARD_LABEL);
  if (parts.length === 1) return message;
  return parts.map((part, index) => (
    <Fragment key={index}>
      {part}
      {index < parts.length - 1 && (
        <Link href={MEMBER_DASHBOARD_URL}>{MEMBER_DASHBOARD_LABEL}</Link>
      )}
    </Fragment>
  ));
};

// Authentication guidance can wrap to several lines. Keep it in the form's
// normal flow so it cannot cover a field or button on narrow screens.
const AuthErrorMessage = ({ message }: { message: string }) =>
  message ? (
    <Typography
      role="alert"
      sx={{ width: "100%", color: commonStyles.errorRed, fontSize: commonStyles.fontSizes.small }}
    >
      {renderMessage(message)}
    </Typography>
  ) : null;

export default AuthErrorMessage;
